var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 6.312,
    viewBox: "0 0 18 6.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Expand_Arrow",
    "data-name": "Expand Arrow",
    d: "M19.937,11.309a.9.9,0,0,0-.189-.3L17.5,8.761a.9.9,0,1,0-1.279,1.279l.72.711H12.806a.9.9,0,0,0,0,1.8h4.133l-.72.711A.9.9,0,1,0,17.5,14.542l2.251-2.251a.931.931,0,0,0,.189-.981ZM9.2,10.751H5.071l.72-.711A.9.9,0,0,0,4.513,8.761L2.262,11.012a.931.931,0,0,0,0,1.279l2.251,2.251a.9.9,0,1,0,1.279-1.279l-.72-.711H9.2a.9.9,0,0,0,0-1.8Z",
    transform: "translate(-2.005 -8.496)",
    fill: "#474b4f",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/ExpandArrow.aa290ae5e883622b3f4caa582b0d665e.svg";
export { ForwardRef as ReactComponent };